//Util to get last route path
const getLastRoutePath = pathName => {
  return pathName.split('/').pop()
}

export { getLastRoutePath }
